export default __webpack_public_path__ + "static/media/pic7.fc59e4f2.jpg";